export default __webpack_public_path__ + "static/media/undersea-static-template.54eddfce.png";